import React, { useEffect, useState } from 'react';
import cs from "./style.module.css";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const Update = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [loggedInUsername, setLoggedInUsername] = useState('');
  const [tableName, setTableName] = useState('');
  const [idNum, setIdNum] = useState('');
  const [result, setResult] = useState('');
  const API_URL = 'https://accessi.sgsmails.com/api.php';

  // Fields to hide
  const hiddenFields = ['ID', 'fr', 'uEmail', 'CreationDate']; // Replace with actual field names

  // Custom labels for fields
  const customLabels = {
    recordD: 'Record Date',
    uEmail: 'No. of Unacceptable Emails',
    do: 'Ordered Date',
    dd: 'Delivered Date',
    eta:"ETA",
    sample: 'Sample Provided',
    ptype: 'Product Type',
    bill: 'Billed Yet'
    // Add more fields as needed  
    // Add more fields as necessary
  };

  // Extracting and setting username from local storage
  useEffect(() => {
    const username = localStorage.getItem('username');
    setLoggedInUsername(username);
  }, []);

  // Fetching data on mount and when location changes
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    const table = pathParts[2];
    const id = pathParts[3];
    setIdNum(id);
    setTableName(table);

    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}?table=${table}&id=${id}`);
        if (Array.isArray(response.data) && response.data.length > 0) {
          setInputs(response.data[0]);
        } else {
          throw new Error('No data found');
        }
      } catch (error) {
        console.error('Failed to fetch data:', error);
        toast.error('Error fetching data.');
      }
    };

    fetchData();
  }, [location.pathname]);

  // Handling changes to all inputs
  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
  };

  // Calculating result and updating state
  useEffect(() => {
    const num1 = parseFloat(inputs.recordD);
    const num2 = parseFloat(inputs.uEmail);
    if (!isNaN(num1) && !isNaN(num2)) {
      setResult(num1 - num2);
    } else {
      setResult('');
    }
  }, [inputs.recordD, inputs.uEmail]);

  // Handling form submission
  const updateData = async (event) => {
    event.preventDefault();

    try {
      const requestData = {
        table: tableName,
        id: idNum,
        ...inputs,
        fr: result,
      };

      const response = await axios.put(`${API_URL}/items`, requestData);

      if (response.data.success) {
        toast.success(`Data updated successfully in ${tableName} table`);
        navigate('/');
      } else {
        toast.error('Error updating data.');
      }
    } catch (error) {
      console.error('Error updating data:', error);
      toast.error('Error updating data.');
    }
  };

  return (
    <div className={`w-full h-auto flex justify-center items-center flex-col p-6 ${cs.bgMain}`}>
      <form onSubmit={updateData} className="md:w-[500px] w-full h-auto p-8 rounded-md bg-white backdrop-filter backdrop-blur-sm bg-opacity-60">
        <h1 className="text-3xl font-bold capitalize">Update {tableName} data</h1>
        <hr className="w-full h-[2px] bg-gray-500 mt-4" />
        <div className="w-full h-auto">
          {Object.keys(inputs)
            .filter((key) => !hiddenFields.includes(key))
            .map((key) => (
              <div key={key} className="w-full h-auto flex justify-start items-center flex-col mt-4">
                <label htmlFor={key} className="text-start w-full text-sm capitalize">
                  {customLabels[key] || key.replace(/([a-z])([A-Z])/g, '$1 $2')}
                </label>
                <input
                  type={key === 'do' || key === 'dd' ? 'date' : 'text'}
                  name={key}
                  id={key}
                  value={inputs[key] || ''}
                  placeholder={customLabels[key] || key}
                  onChange={handleChange}
                  className={`w-full h-auto py-1 px-2 outline-none mt-2 ${loggedInUsername === "admin" ? 'text-gray-700' : 'text-gray-300'}`}
                  readOnly={loggedInUsername !== "admin"}
                />
              </div>
          ))}
          <div className="w-full h-auto flex justify-start items-center flex-col mt-4">
            <label htmlFor="uEmail" className="text-left w-full text-sm">No. of Unacceptable Emails</label>
            <input
              type="text"
              name="uEmail"
              id="uEmail"
              value={inputs.uEmail || ''}
              placeholder="No. of Unacceptable Emails"
              onChange={handleChange}
              className="w-full h-auto py-1 px-2 outline-none mt-2"
            />
          </div>
          <div className="w-full h-auto flex justify-start items-center flex-col mt-4">
            <label htmlFor="fr" className="text-left w-full text-sm">Final No. of Records</label>
            <input
              type="text"
              name="fr"
              id="fr"
              value={result || ''}
              placeholder="Final No. of Records"
              className={`w-full h-auto py-1 px-2 outline-none mt-2 ${loggedInUsername === "admin" ? 'text-gray-700' : 'text-gray-300'}`}
              readOnly
            />
          </div>
          <button type="submit" className="w-full bg-green-600 text-white rounded-sm py-1 mt-4 hover:bg-green-800">UPDATE</button>
        </div>
      </form>
      <div className="w-full h-auto my-6">
        <h1>View All {tableName} Data!! <Link className="text-blue-600 underline" to={'/'}>View</Link></h1>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Update;